// extracted by mini-css-extract-plugin
export var dateContainer = "styles-module--dateContainer--WVf5N";
export var dateCss = "styles-module--dateCss---TnH1";
export var dayCss = "styles-module--dayCss--oCmly";
export var description = "styles-module--description--JgzvS";
export var eventContainer = "styles-module--eventContainer--WHXej";
export var eventItem = "styles-module--eventItem--iEdsi";
export var eventTitle = "styles-module--eventTitle--as3TS";
export var icon = "styles-module--icon--RMLxL";
export var image = "styles-module--image--qvBW5";
export var time = "styles-module--time--fX+7H";
export var title = "styles-module--title--4AmtM";